import { render, staticRenderFns } from "./CreateDockerView.vue?vue&type=template&id=3cd1845a&scoped=true"
import script from "./CreateDockerView.vue?vue&type=script&lang=js"
export * from "./CreateDockerView.vue?vue&type=script&lang=js"
import style0 from "./CreateDockerView.vue?vue&type=style&index=0&id=3cd1845a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd1845a",
  null
  
)

export default component.exports